<template>
  <div style="padding-left: 10px; padding-right: 10px">
    <p style="text-align:center;line-height:30px">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >电商平台用户服务协议</span
      >
    </p>
    <p
      style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left"
    >
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >&nbsp;</span
      ><span
        style="font-size:12px;margin-left: 10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >服务协议（以下简称“本协议”）由</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >南京大衍数字科技有限公司</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（以下简称“本公司”）和您（也称“用户”）签订。</span
      >
    </p>
    <h1 style="text-align:justify;text-justify:inter-ideograph">
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >一、声明与承诺</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
        ><br /> </span
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
          >（一）在接受本协议或您以本公司允许的其他方式实际使用本公司服务之前，请您仔细阅读本协议的全部内容（特别是以粗体标注的内容）。</span
        ></strong
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
        ><br /> </span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
        >（二）如果您不同意本协议的任意内容，或者无法准确理解本公司对条款的解释，请不要进行后续操作，包括但不限于不要接受本协议、不使用本服务。如果您对本协议的条款有疑问，请通过本公司客服渠道进行询问，本公司将向您解释条款内容。<br /> </span
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
          >（三）本公司需要对本协议进行变更或修改的，将通过手机客户端公告提前予以公布，若您未在公告期内提出异议，公告期限届满后即时生效；若您在公告期内提出异议，大衍将与您协商解决。</span
        ></strong
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
        ><br /> </span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
        >（四）如您为无民事行为能力人或为限制民事行为能力人，例如您未满18周岁，则您应在监护人监护、指导下审慎阅读本协议并使用本服务。若您非自然人，则您确认，在您取得大衍账户时，或您以其他本公司允许的方式实际使用大衍服务时，您为在中国大陆地区合法设立并开展经营活动或其他业务的法人或其他组织，且您订立并履行本协议不受您所属、所居住或开展经营活动或其他业务的国家或地区法律法规的排斥。不具备前述条件的，您应立即终止注册或停止使用大衍服务。<br />
        （五）您在使用本公司大衍服务时，应自行判断交易对方是否具有完全民事行为能力并自行决定是否使用大衍服务与对方进行交易，且您应自行承担与此相关的风险。&nbsp;<br />
        （六）您承诺不利用本公司提供的商城服务从事或者协助他人从事非法活动，不得存在制作、发布、传播违法信息等行为，您实施的所有行为均遵守国家相关法律、法规、部门规章等规范性文件和本公司的相关规定，不违反社会公共利益或公共道德。您从事非法活动或不正当交易产生的一切后果与责任，由您独立承担。<br />
        （七）如果您提供任何不真实、不准确、不完整或不能反映当前情况资料的，或本公司有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况的，本公司保留停止您使用大衍服务的权利，如因您资料的不真实、不准确、不完整或不能反映当前情况而给本公司或其关联公司或任何其他第三方造成损失的，您应负责赔偿。<br />
        二</span
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
          >、我们如何收集您的个人信息</span
        ></strong
      >
    </h1>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用产品与/或服务过程中主动提供或因使用产品与/或服务而产生的个人信息，以及从第三方获取您的相关个人信息</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >。<strong
          >如果我们要将您的个人信息用于本政策未载明的其它用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。</strong
        ></span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（一）我们如何收集您的信息</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >我们会通过如下三种渠道获取您的个人信息：</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >1</span
        ></strong
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >、您直接提供的信息：</span
        ></strong
      ><span
        style="font-size: 12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >我们可能收集并存储您在使用电商服务时向我们提供的信息，包括您在我们页面中在线填写信息时、申请产品与/或服务时、参与网络社区讨论时、解决争议或就电商服务与我们联系时所<strong>提供的信息</strong>，以及您在使用我们服务过程中<strong>产生的关于您的交易和活动的信息</strong>。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（二）我们收集您的哪些信息</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >在实现电商服务以下各项业务功能的过程中，我们需要收集您的一些信息，用以向您提供服务、提升我们的服务质量、保障您的账号和资金安全以及符合国家法律法规及监管规定。<strong
          >请您注意，如果您提供的是他人个人信息，请您确保已取得相关主体的授权。</strong
        ></span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >1</span
        ></strong
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >、账号注册与登录</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >电商服务中的账号登录服务由我司提供，您需要注册账号登录电商服务。在此过程中，为对您的账号进行验证以实现登录目的，大衍将按照《隐私政策》的约定收集、存储您的<strong>账号名、密码、手机号码</strong>用于账号注册与登录的基础账号信息和您自行选择补充提供的<strong>头像、昵称</strong>等其他账号信息，请您在使用账号登录功能前仔细阅读</span
      ><span style="font-size:12px"
        ><a href="https://in.m.jd.com/help/app/register_info.html"
          ><em
            ><span style="font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
              >《用户服务协议》</span
            ></em
          ></a
        ></span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、</span
      ><span style="font-size:12px"
        ><a href="https://in.m.jd.com/help/app/private_policy.html"
          ><em
            ><span style="font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
              >《隐私政策》</span
            ></em
          ></a
        ></span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >项下的相关内容。同时，在您使用账号登录电商服务的过程中，为将您的账号与您在电商服务上的操作行为相关联，我们将向大衍收集您的账号信息，包括<strong>账号名、手机号码、昵称、头像</strong>，收集这些信息是用于为您提供账号登录服务以及保障您的账号安全，若您不提供上述信息，则您无法正常登录电商服务。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >2</span
        ></strong
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >、实名认证</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >在您使用支付服务、信用服务、退款服务、佣金服务、商城服务时，为了遵守适当性管理及履行反洗钱、羊毛党要求，我们需要首先认证您身份的真实性，为此您需要提供您的身份基本信息<strong>（姓名、性别、国籍、职业、住所地或者工作单位地址、手机号、身份证件或者身份证明文件的种类、号码和有效期限信息</strong>；在发生法律法规及监管规定的特定情形时，还需要您提供<strong>身份证件彩色照片或影印件</strong>以供我们核对并留存。根据相关法律法规的规定，您需通过身份基本信息多重交叉验证后方可使用我们的服务。在进行多重身份验证时，若通过<strong>绑定银行卡进行身份实名认证的</strong>，我们还需要您提供<strong>银行卡信息和银行预留手机号</strong>；若通过刷脸进一步确认您提供信息的准确性时，我们还需要您提供<strong>脸部图像/视频。</strong>我们会将上述信息提交给合法持有您上述信息的第三方身份验证机构，以便对您所提供信息的准确性进行核对如果您不提供上述信息或您的实名验证未通过，则您无法使用上述服务。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >3</span
        ></strong
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >、商城服务功能</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >您在使用电商服务商城服务功能，包括支付、转账、信用卡还款、红包、扫一扫、付款码、刷脸支付、指纹支付、支付优惠时<strong>，</strong>我们将会使用您的<strong>姓名、国籍、性别、职业、住址、联系方式、身份证件的种类、号码和有效期、账号、开户行、银行卡号、银行预留手机号、银行卡有效期、订单信息、交易记录、转账记录、面部信息、指纹验证结果信息</strong>，为您提供商城服务，如您不提供上述信息，我们无法提供相关商城服务或功能。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >4</span
        ></strong
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >、提供客户服务及进行投诉处理</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >我们的客服系统会使用您的<strong>账号信息</strong>和<strong>交易信息、支付信息。</strong>为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的<strong>账号信息</strong>与您核验您的身份。当您需要我们提供与您交易信息相关的客服与售后服务时，我们将会查询您的<strong>交易信息</strong>。此外，我们还会收集您与客服联系时<strong>您反馈意见、建议或举报时提供的信息</strong>，您<strong>参与问卷调查时向我们发送的信息</strong>。如您不提供前述信息，不影响您使用我们提供的其他服务。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >5</span
        ></strong
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >、广告功能</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >为更好地向用户提供服务，我们还可能通过站内信、PUSH通知、手机短信、电话方式向您推送我们认为您可能会感兴趣的广告和其它商业信息，如您不想收到此类广告的通知，可以根据本政策进行退订。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >为了向您提供更契合您需求的服务，我们可能会将您的注册信息、<strong>交易信息</strong>、<strong>浏览信息</strong>、关注的信息和我们自行采集的您的个人信息进行关联并进行数据分析以形成客户画像，用来向您推荐您感兴趣的产品和/或服务。如果您不想收到个性化推荐内容，您可以关闭相关功能。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >三、征得授权同意的例外</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >依据相关法律法规及国家标准，以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、与国家安全、国防安全直接有关的；&nbsp;</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、与公共安全、公共卫生、重大公共利益直接有关的；&nbsp;</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、与犯罪侦查、起诉、审判和判决执行等直接有关的；&nbsp;</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >4</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；&nbsp;</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >5</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、所收集的个人信息是个人信息主体自行向社会公众公开的；&nbsp;</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >6</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、从合法公开披露的信息中收集的您的个人信息的；&nbsp;</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >7</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、根据您的要求签订和履行合同所必需的；&nbsp;</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >8</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置服务的故障；&nbsp;</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >9</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、法律法规规定的其他情形。</span
      >
    </p>
    <p>
      <em
        ><strong
          ><span
            style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
            >&nbsp;</span
          ></strong
        ></em
      >
    </p>
    <h1 style="text-align:justify;text-justify:inter-ideograph">
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
          >四、我们如何使用您的个人信息</span
        ></strong
      >
    </h1>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、为了遵守国家法律法规及监管要求，以及向您提供服务及提升服务质量，或保障您的账号和资金安全，我们会在以下情形中使用您的信息：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（1）实现本政策“我们收集您的哪些信息”约定的目的。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（2）为了保障服务的稳定性与安全性，我们会将您的信息用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（3）为了使您知晓使用我们服务的状态，我们会向您发送服务提醒。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（4）根据法律法规或监管要求向相关部门进行报告。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（5）邀请您参与我们服务有关的客户调研。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（6）提高、完善和优化电商服务在线服务。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（7）处理您对电商服务产品与/或服务的申请或反馈请求。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（8）我们通过技术手段对数据进行去标识化处理后，去标识化处理的信息将无法识别主体。<strong
          >请您了解并同意，在此情况下我们有权使用已经去标识化的信息；在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</strong
        ></span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（9）我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏展示，以保护您的信息安全。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >3</span
        ></strong
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >、</span
        ></strong
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。<strong
          >请您理解，我们向您提供的产品与/或服务将不断更新变化。如果您选择使用本政策中尚未列明的其他产品与/或服务时，在我们收集您的个人信息前，我们会通过业务协议、页面提示的方式向您详细说明信息收集的目的、方式、范围并征求您的明确同意。若您不同意提供前述信息，您可能无法使用该项服务，但不影响您使用其他服务。</strong
        ></span
      >
    </p>
    <h1 style="text-align:justify;text-justify:inter-ideograph">
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
          >五、我们如何委托处理、共享、转让、公开披露您的个人信息</span
        ></strong
      >
    </h1>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（一）委托处理</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >为了提高效率、降低成本，我们可能会委托关联公司或其他专业服务提供商代表我们来处理信息，例如我们会聘请服务提供商为我们提供基础设施技术服务、信贷审批服务、客户支持服务。对我们委托处理个人信息的公司、组织和个人，我们会通过书面协议、现场审计等方式要求其遵守严格的保密义务并采取有效的保密措施，要求其只能在委托范围内处理您的信息，而不得出于其自身利益使用您的信息。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（二）共享</span
        ></strong
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >我们不会与电商服务以外的任何公司、组织和个人共享您的个人信息，除非获得您的明确同意或属于“</span
        ></strong
      ><span style="font-size:12px"
        ><a
          href="https://h5.m.jd.com/dev/r6GfckUwQej2Y4JK3nn1whkLv2k/index.html?utm_term=wxfriends&utm_source=iOS_url_1619423530625&utm_medium=jrappshare#_%E4%BA%8C%E3%80%81%E6%88%91%E4%BB%AC%E5%A6%82%E4%BD%95%E4%BD%BF%E7%94%A8%E6%82%A8%E7%9A%84%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF"
          ><em
            ><span style="font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
              >共享、转让、公开披露个人信息时事先征得授权同意的例外</span
            ></em
          ></a
        ></span
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >”。我们可能会向关联公司、合作伙伴等第三方共享您的个人信息，以保障为您提供的服务顺利完成；但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。该等第三方无权将共享的个人信息用于任何其他用途。</span
        ></strong
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的协议、本政策要求的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。我们将按照法律法规及国家标准的要求以点击确认协议、具体场景下的点击确认动作等形式征求您的同意。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（三）转让</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、在获得您的明确同意后，我们会向其他方转让您的个人信息；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（四）公开披露</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >除在公布中奖活动名单时会脱敏展示<strong>中奖者手机号</strong>或<strong>账号名</strong>外，我们仅会在以下情况下，才会公开披露您的个人信息：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、获得您的明确同意后，按您明确同意的披露方式披露您所指定的个人信息；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（五）共享、转让、公开披露个人信息时事先征得授权同意的例外</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >根据相关法律法规及国家标准，以下情形中，我们共享、转让、公开披露您的个人信息不必事先征得您的授权同意：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、与您履行法律法规规定的义务相关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、与国家安全、国防安全直接相关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、与公共安全、公共卫生、重大公共利益直接相关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >4</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、与刑事侦查、起诉、审判和判决执行等直接相关的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >5</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >6</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、您自行向社会公众公开的个人信息；</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >7</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >&nbsp;</span
      >
    </p>
    <h1 style="text-align:justify;text-justify:inter-ideograph">
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
          >六、我们如何保护您的个人信息</span
        ></strong
      >
    </h1>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（一）我们保护您个人信息的技术与措施</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：<em
          ><strong>&nbsp;</strong></em
        ></span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >1</span
        ></strong
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >、数据安全技术措施</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >我们已采用符合业界标准的安全防护措施以及行业内通行的安全技术来防止您的个人信息遭到未经授权的访问、修改，避免您的个人信息泄露、损坏或丢失：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（1）采取加密技术对您的个人信息进行加密存储，我们存储您个人数据的系统已通过&nbsp;PCI
        DSS（第三方支付行业数据安全标准）认证，从安全管理、策略、过程、网络体系结构等诸多方面保障交易及个人信息安全。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（2）我们的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保您的个人信息在传输过程中的安全。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（3）在使用您的个人信息时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、SHA256在内的多种数据脱敏技术增强个人信息在使用中的安全性。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（4）我们会采用白盒代码安全检测、黑盒安全测试、入侵检测防御技术进行恶意代码防范措施保护您的个人信息安全。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >2</span
        ></strong
      ><strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >、为保护个人信息采取的其他安全措施</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >我们通过建立数据分类分级、数据安全管理规范、安全开发规范来管理规范个人信息的存储和使用：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（1）我们采用严格的数据访问权限和多重身份认证技术控制和保护个人信息，通过与信息接触者签署严格的保密协议、监控和审计机制来对数据进行全面安全控制，避免数据被违规使用。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（2）我们采用代码安全检查、数据访问日志分析技术进行个人信息安全审计。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（3）我们建立了信息安全委员会并下设信息安全小组，由各小组信息安全专员负责个人信息安全事务。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（4）我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（二）我们如何存储和保存您的个人信息</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、我们仅在本政策所述目的所必需期间和法律法规及监管规定的时限内保存您的个人信息。我们承诺为了保证您的消费者权益，除非法律法规另有规定，您的<strong>个人信息我们将保存至您账号注销之日后的两个月</strong>。当您的个人信息超出我们所保存的期限后，我们会对您的个人信息进行删除或匿名化处理。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、在您终止使用我们的服务后，我们会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。如果我们终止服务或运营，我们将及时停止收集您个人信息的活动，至少提前三十天通知您，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >&nbsp;</span
      >
    </p>
    <h1 style="text-align:justify;text-justify:inter-ideograph">
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
          >七、您的权利</span
        ></strong
      >
    </h1>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >电商服务非常重视您对个人信息的关注，按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，尽全力保障您对自己的个人信息行使以下权利：</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（一）访问您的个人信息</span
        ></strong
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、您有权随时访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（1）您的账号信息</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >（2）您的交易信息</span
      >
    </p>
    <p>
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >（四）注销您的账户</span
        ></strong
      >
    </p>
    <p
      style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;text-indent:28px;line-height:30px"
    >
      <strong
        ><span
          style="font-size: 12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >您可以在我们的产品与/或服务中直接申请注销账号或注销您申请的具体服务功能，还可以通过约定的联系方式与我们联系，经核实您的注销信息、您的合同履行情况等具体细节后，我们对您的注销账</span
        ></strong
      >
    </p>
    <h1 style="text-align:justify;text-justify:inter-ideograph">
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;font-weight:normal"
          >八、我们如何处理儿童的个人信息</span
        ></strong
      >
    </h1>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >1</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、我们的产品、网站和服务主要面向成人。若您是14周岁以下的儿童，在使用我们的产品与/或服务或向我们提供您的个人信息前，<strong>应事先取得您家长或法定监护人的同意</strong>。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >2</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、对于经父母或其他监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或其他监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >3</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人视为儿童。</span
      >
    </p>
    <p>
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >4</span
      ><span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >、如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了儿童的个人信息，或儿童的父母或其他监护人撤回其同意的，则会设法尽快删除相关数据。<a
          name="_GoBack"
        ></a
      ></span>
    </p>
    <p
      style="margin-top:20px;text-align:left;line-height:40px;border:none;padding:0;padding:0 0 0 0"
    >
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >九、其他规定</span
        ></strong
      >
    </p>
    <p
      style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px"
    >
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >10.1 </span
      ><span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</span
      >
    </p>
    <p
      style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px"
    >
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >10.2 </span
      ><span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >本协议中的标题仅为方便阅读而设，不应影响对本协议条款的理解。</span
      >
    </p>
    <p
      style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px"
    >
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >10.3 </span
      ><span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >隐私保护：保护用户隐私和其他个人信息是大衍的一项基本政策，具体内容详见大衍相关隐私政策。</span
      >
    </p>
    <p
      style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px"
    >
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >10.4 </span
      ><span
        style="font-size:12px;font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >鉴于有关法律法规正在持续不断的完善，如相关法律规定与本协议有冲突之处，以相关法律规定为准。</span
      >
    </p>
    <p
      style="margin-top:20px;text-align:left;line-height:40px;border:none;padding:0;padding:0 0 0 0"
    >
      <strong
        ><span
          style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
          >十、意见及建议</span
        ></strong
      >
    </p>
    <p
      style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:left;line-height:30px"
    >
      <span
        style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;"
        >用户对大衍服务有任何意见或建议，可向大衍官方网站右下端标注的联系方式反馈，大衍愿意倾听并尊重每一位用户的意见，并将尽力为用户提供最优质的服务。</span
      >
    </p>
    <p>
      <br />
    </p>
  </div>
</template>
<script>
export default {
  name: "ServiceProtocol",
  components: {},
  props: {},
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
